/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any, no-extend-native */
// This must be the first line in src/index.js
import 'react-app-polyfill/ie11';
import 'core-js/es/string/starts-with';
import 'core-js/es/string/pad-start';
import 'core-js/es/string/repeat';
import 'core-js/es/symbol';
import 'core-js/es/array';
import 'core-js/es/object/entries';
import 'core-js/es/object/values';
import './polyfills';
import { render } from 'react-dom';
import React from 'react';
import { initStore } from './utils/StoreUtils';
import App from './components/common/layout/App';
import AppProviders from './components/common/AppProviders';
import GlobalStyle from './components/common/GlobalStyle';
import * as SystemActions from './store/system/actions';
import './static/css/normalize.css';
import './static/css/app.css';
import './static/css/highcharts-dark-unica-import.css';
import * as serviceWorker from './serviceWorker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { store, history } = initStore();

store
  .dispatch(SystemActions.init())
  .then(() => {
    render(
      <AppProviders store={store} history={history}>
        <React.Fragment>
          <GlobalStyle />
          <App />
        </React.Fragment>
      </AppProviders>,
      document.getElementById('root') as HTMLElement,
    );
  })
  .catch((error: any) => {
    console.error(`Could not initialize Insights App: ${error}`);
    render(<h2>Error: Could not initialise Insights</h2>, document.getElementById('root') as HTMLElement);
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
